import { createSlice } from "@reduxjs/toolkit";
import {
  fetchEmailTemplate,
  previewEmailTemplate,
  resetEmailTemplate,
  updateEmailTemplate,
} from "./emailTemplatesThunks";

const initialState = {
  isLoading: false,
  isSaving: false,
  isPreviewing: false,
  // The last template loaded or saved: { key, subject, body, fields, customized, last_updated_by, last_updated_at }
  data: null,
};

const storeTemplate = (state, { payload }) => {
  state.isLoading = false;
  state.isSaving = false;
  state.data = payload;
};

export const emailTemplates = createSlice({
  name: "emailTemplates",
  initialState,
  reducers: {
    clearEmailTemplate: {
      reducer(state) {
        state.isLoading = false;
        state.isSaving = false;
        state.isPreviewing = false;
        state.data = null;
      },
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmailTemplate.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchEmailTemplate.fulfilled, storeTemplate)
      .addCase(fetchEmailTemplate.rejected, (state) => {
        state.isLoading = false;
        state.data = null;
      })
      .addCase(updateEmailTemplate.pending, (state) => {
        state.isSaving = true;
      })
      .addCase(updateEmailTemplate.fulfilled, storeTemplate)
      .addCase(updateEmailTemplate.rejected, (state) => {
        state.isSaving = false;
      })
      .addCase(resetEmailTemplate.pending, (state) => {
        state.isSaving = true;
      })
      .addCase(resetEmailTemplate.fulfilled, storeTemplate)
      .addCase(resetEmailTemplate.rejected, (state) => {
        state.isSaving = false;
      })
      .addCase(previewEmailTemplate.pending, (state) => {
        state.isPreviewing = true;
      })
      .addCase(previewEmailTemplate.fulfilled, (state) => {
        state.isPreviewing = false;
      })
      .addCase(previewEmailTemplate.rejected, (state) => {
        state.isPreviewing = false;
      });
  },
});

export const { clearEmailTemplate } = emailTemplates.actions;

export default emailTemplates.reducer;
